(function () {
    'use strict';

    angular
        .module('app.dailyLogs')
        .controller('DailyLogsController', DailyLogsController);

    DailyLogsController.$inject = ['$scope', 'common', 'dataservice', 'carousel.dialog', 'backendHubProxy', 'logEntryViewDialog', 'completions'];
    /* @ngInject */
    function DailyLogsController($scope, common, dataservice, carouselDialog, backendHubProxy, logEntryViewDialog, completions) {
        var vm = this;
        vm.common = common;
        vm.title = "Daily Logs";
        vm.items = [];
        vm.isLoading = true;
        vm.onDate = common.getMainState("mainDate");
        vm.completions = completions;
        vm.refresh = getItems;
        vm.canEdit = canEdit;
        vm.displayedItems = [];
        vm.showAttachment = showAttachment;
        vm.logTypes = [];
        vm.items = [];
        vm.isLogType = isLogType;
        vm.canDelete = canDelete;
        vm.showEntry = showEntry;
        
        vm.deletingEntryId = -1;
        vm.originalEntry = {};
       
        
        vm.deleteEntry = deleteEntry;
  

        $scope.$on('$destroy', function () {
            backendHubProxy.stop();
        });

        activate();

        function activate() {
            backendHubProxy.displayedItems = vm.displayedItems;
            backendHubProxy.startListening();

            common.notifier.subscribe(common.config.events.mainDateChange, $scope, dateChanged);
            var promises = [getItems()];
            return common.$q.all(promises).then(function () {
                common.logger.info('Activated ' + vm.title + ' View');
                vm.isLoading = false;
                common.notifier.notify(common.config.events.refreshCounts);
            }, function (error) { });
        }

        function showEntry(logTypeId, entryId) {
            logEntryViewDialog.display(logTypeId, entryId).then(function () { }, function () { });
        }
        
        function isLogType(logType) {
            return function (item) {
                return item.LogTypeId == logType.ID;
            }
        }

        function showAttachment(item) {
            dataservice.getItems('api/Attachments/GetForParentType/8/' + item.ID).then(function (response) {
                return carouselDialog.display(response.data).then(function () { }, function () { });
            }, function (error) { });
        }

        function canEdit(item) {
            if (common.userService.userType() == "0") {
                return common.userService.userId() == item.CreatedById;
            }
            else {
                return true;
            }
        }

        function canDelete(item) {
            if (common.userService.userType() == "0") {
                return common.userService.userId() == item.CreatedById;
            }
            else {
                return true;
            }
        }


        function deleteEntry(item) {
            var id = item.ID;
            dataservice.deleteItem('api/DailyLogs/DeleteEntry/' + id).then(function (saveResult) {
                vm.isSaving = false;
                vm.deletingEntryId = -1;
                $.each(vm.items, function (index, result) {
                    if (result) {
                        if (result["ID"] == id) {
                            vm.items.splice(index, 1);
                        }
                    }
                })
            }, function (error) { });
        }

        function getItems() {
            var m = moment(vm.onDate).format("YYYY-MM-DD");
            return dataservice.getItems('api/DailyLogs/GetForDate?forDate=' + m).then(function (response) {
                var d = response.data;
                vm.logTypes = d.LogTypes;
                vm.items = d.Entries;
                vm.completionTypes = d.CompletionTypes
                backendHubProxy.items = vm.items;
                return vm.items;
            }, function (error) { });
        }

        function dateChanged(eventName, newDate) {
            vm.onDate = newDate;
            getItems();
        }

    }
})();
